// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"src_styles_globals_scss-src_styles_globals_scss":"d867ab49","src_styles_index_less-_f290":"c2a01799"}[chunkId] + ".chunk.css";
};